module.exports = __webpack_public_path__ + "static/media/Skating.07f1a1ef.png";